import { render, staticRenderFns } from "./RetakeManagement.vue?vue&type=template&id=74a8d760"
import script from "./RetakeManagement.vue?vue&type=script&lang=js"
export * from "./RetakeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports